import axios from "axios";
import Config from "../../../config";

const v2_actionSalvarCustomFieldValue = (leadId, fieldId, data) => {
    return axios({
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/crm/leads/${leadId}/custom-fields/${fieldId}/salvar`,
        data
    });
};

export default v2_actionSalvarCustomFieldValue;
